<template>
    <div class="tab-one-container">
        <video src="http://help.web724.cn/video/job_video-createPC.mp4" autoplay controls loop></video>
        <p class="step" @click="$emit('step','2')">下一步</p>
    </div>
</template>

<script>
export default {
	name: 'TabOne',
	methods: {
		step() {
			this.$emit('step', '2')
		}
	}
}
</script>

<style scoped lang="scss">
    .tab-one-container{
        height: 100%;
        width:100%;padding-bottom: 40px;
        video{width: 100%;height:100%;}
        p.step{
            position: absolute; left:20px;
            width: 100%;
            bottom:0;
            cursor:pointer;
            line-height: 40px;
            padding-right:45px;text-align: right;
        }

    }
</style>
